'use client';

import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface ScrollingBannerProps {
  children: ReactNode;
  duration?: number;
  repeatCount?: number;
}

export const ScrollingBanner = ({
  children,
  duration = 50,
  repeatCount = 3,
}: ScrollingBannerProps) => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) =>
      setPrefersReducedMotion(e.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="flex overflow-hidden" role="marquee" aria-live="off">
      <motion.div
        className="flex shrink-0"
        animate={prefersReducedMotion ? {} : { x: ['0%', '-50%'] }}
        transition={{
          duration: prefersReducedMotion ? 0 : duration,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        {Array.from({ length: repeatCount }).map((_, i) => (
          <div key={i} className="flex shrink-0">
            <div className="flex items-center gap-24 bg-[#FF5C36]">
              {children}
            </div>
            <div className="flex items-center gap-24 bg-B-500">{children}</div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};
